import { render, staticRenderFns } from "./position-modal.vue?vue&type=template&id=2d1e89d4"
import script from "./position-modal.vue?vue&type=script&lang=js"
export * from "./position-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports